import { Injectable } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { getDefaultControlValue } from '@gk/gk-modules';
import { ECSControlName } from '../../../../../components/electronic-correspondence-statement/models/form/form.model';
import { BaseNewRequestFormService } from '../../../../../shared/base-new-request-form/base-new-request-form.service';
import { DocumentationFormType } from '../../../../../shared/base-new-request/base-new-request.model';
import { LOIDNewRequestControlName } from './new-request-form.model';

@Injectable({
  providedIn: 'root',
})
export class LOIDNewRequestFormService {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private baseNewRequestFormService: BaseNewRequestFormService,
  ) {}

  getFormGroup(): UntypedFormGroup {
    return this.formBuilder.group({
      ...this.baseNewRequestFormService.getCommonApplicantFormGroup(
        {
          [LOIDNewRequestControlName.ProxyDetailsCheckbox]: false,
          [ECSControlName.ElectronicCorrespondenceStatement]: false,
        },
        {
          documentationFormType: DocumentationFormType.NonElectronicForm,
        },
      ).controls,
      [LOIDNewRequestControlName.RoadNumber]: [
        getDefaultControlValue(),
        Validators.required,
      ],
      [LOIDNewRequestControlName.Place]: [
        getDefaultControlValue(),
        Validators.required,
      ],
      [LOIDNewRequestControlName.Street]: [getDefaultControlValue()],
      [LOIDNewRequestControlName.LaneOccupancyPurpose]: [
        getDefaultControlValue(),
        Validators.required,
      ],
      [LOIDNewRequestControlName.LaneOccupancyDate]: [
        getDefaultControlValue(),
        Validators.required,
      ],
      [LOIDNewRequestControlName.AreaOfRoadEngineeringFacilities]: [
        getDefaultControlValue(),
      ],
      [LOIDNewRequestControlName.AreaWithoutRoadEngineeringFacilities]: [
        getDefaultControlValue(),
      ],
    });
  }
}
